import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import i18next from 'i18next';
import { getFullBackendUrl } from 'helper/download';

export interface BookingRequestFileItem {
  id: number;
  originalFilename: string;
}

/**
 * Download rows for documents the booker attached to the request.
 *
 * @param props.files - File metadata from the booking request.
 * @returns Nothing when there are no files.
 */
export default function BookingRequestFiles({ files }: { files: BookingRequestFileItem[] }) {
  if (!files.length) return null;

  return (
    <Box mt={1} mb={1}>
      {files.map(file => (
        <Box key={file.id} display="flex" alignItems="center" gap={1} py={0.25}>
          <InsertDriveFileOutlinedIcon fontSize="small" color="action" />
          <Typography variant="body2" sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {file.originalFilename}
          </Typography>
          <IconButton
            size="small"
            aria-label={i18next.t('customer-request-file-download') || 'Download'}
            onClick={() => window.open(getFullBackendUrl(`/backend/spacefiles/download/${file.id}`), '_blank')}
          >
            <DownloadIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
}
